export const engagementWidgetMinimizedItemName = "auwsEWMinimized"
export const engagementWidgetPromptClosedItemName = "auwsEWExtraWrapperClosed"
